/* eslint-disable no-undef */

const defaultKeyName = 'workout-student';

const getStorageKey = () => localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_KEY || defaultKeyName);

const get = () => {
  const storage = getStorageKey();

  if (null !== storage) {
    return JSON.parse(storage);
  }

  return null;
};

const set = (data) => {
  localStorage.setItem(defaultKeyName, JSON.stringify(data));
};

const addValue = (key, value) => {
  let storage = get();

  if (storage === null) {
    storage = {};
  }

  storage[key] = value;

  set(storage);
};

const removeValue = (key) => {
  const storage = get();
  if (storage === null) {
    return;
  }
  delete storage[key];
  set(storage);
};

const removeKey = (key) => removeValue(key);

export default {
  get,
  set,
  addValue,
  removeKey,
  removeValue,
}
